import script from "./banner-operation.vue?vue&type=script&setup=true&lang=js"
export * from "./banner-operation.vue?vue&type=script&setup=true&lang=js"

import "./banner-operation.vue?vue&type=style&index=0&id=00ba9121&lang=scss&scoped=true"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ba9121"]])

export default __exports__